"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogUploadType = void 0;
var CatalogUploadType;
(function (CatalogUploadType) {
    CatalogUploadType["Manual"] = "manual";
    CatalogUploadType["Automatic"] = "automatic";
})(CatalogUploadType || (exports.CatalogUploadType = CatalogUploadType = {}));
